import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@components/atoms/button';
import { ROUTES } from '@constants';
import { useToast } from '@hooks/use-toast';
import { useLazyGetVerificationByShortIdQuery } from '@modules/dashboard/api/verifications-api';
import { useAppSelector } from '@store';

export const PreviewButton: React.FC = () => {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const navigate = useNavigate();
    const organizationId = useAppSelector((state) => state.dashboard.session.organizationId);
    const id = useAppSelector((state) => state.docsVerification.sdkOptions?.id);
    const [getVerificationByShortId, { isLoading }] = useLazyGetVerificationByShortIdQuery();
    const errorMessage = useMemo(() => t('common.pleaseTryAgainLater'), [t]);
    const onVerificationPreviewClick = useCallback(async () => {
        try {
            if (!id) {
                return;
            }
            const response = await getVerificationByShortId({
                organizationId,
                id,
            }).unwrap();

            navigate(`${ROUTES.KYC.DOCVER.RESULT}${response.id}`);
        } catch {
            showToast({
                variant: 'error',
                title: t('common.somethingWentWrong'),
                message: errorMessage,
            });
        }
    }, [id, getVerificationByShortId, organizationId, navigate, showToast, t, errorMessage]);

    return (
        <Button
            variant='tertiary'
            onClick={onVerificationPreviewClick}
            className='button-redirect'
            size='xl'
            loading={isLoading}
        >
            {t('docVerificationWidget.finish.checkVerificationDetails')}
        </Button>
    );
};
